import { SnackbarOrigin } from "@mui/material";
import { components } from "../../../types/api";

export type SimulatedRole = components["schemas"]["Role"];

export type AppStateType = {
  toastMessage: ToastMessage | null;
  language: LanguageEnum;
  sidebarCollapsed: boolean;
  // Lets an admin temporarily preview the app as another role without
  // touching the real user record — UI-only, never sent to the backend.
  simulatedRole: SimulatedRole | null;
};

export enum LanguageEnum {
  EN = "en",
  ES = "es",
}

export type ToastMessage = {
  message: string;
  severity?: "success" | "error" | "warning" | "info";
  autoHideDuration?: number;
  anchorOrigin?: SnackbarOrigin;
};

export const APP = "app";
